import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'
import { EVENT_STATUS_PUBLISHED } from '../../../constants'

const useStyles = makeStyles({
  pill: {
    display: 'inline-block',
    borderRadius: 12,
    padding: '4px 12px',
    fontSize: 12,
    fontWeight: 600,
  },
  published: { backgroundColor: '#e9fdf3', color: '#008e5b' },
  draft: { backgroundColor: '#ebeff5', color: '#374158' },
})

const StatusPill = ({ status }) => {
  const styles = useStyles()
  const isPublished = status === EVENT_STATUS_PUBLISHED
  return (
    <span className={clsx(styles.pill, isPublished ? styles.published : styles.draft)}>
      {status}
    </span>
  )
}

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
}

export default StatusPill
